// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-form-shell {
  background: radial-gradient(120% 120% at 20% 20%, #f5f7fb, #e7ecf7 55%, #dfe6f5);
  border-radius: 20px;
  padding: 18px;
  border: 1px solid rgba(12, 20, 39, 0.06);
}

.form-hero {
  text-align: left;
  margin-bottom: 18px;
}

.form-hero .badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.18);
  color: #1d4ed8;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.form-hero h1 {
  margin: 10px 0 6px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
}

.form-hero p {
  margin: 0;
  color: #4b5563;
  font-size: 13px;
}

.form-panel {
  background: #ffffff;
  border: 1px solid rgba(12, 20, 39, 0.08);
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(45, 55, 72, 0.15);
  padding: 18px;
  max-height: 72vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: 100%;
  min-height: 0;
}

.form-content {
  display: grid;
  gap: 14px;
  overflow-y: auto;
  padding-right: 4px;
  min-height: 0;
  flex: 1 1 auto;
}

.fieldset {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03), rgba(255, 255, 255, 0.96));
  border: 1px solid rgba(12, 20, 39, 0.06);
  border-radius: 14px;
  padding: 14px;
  display: grid;
  gap: 12px;
}

.fieldset-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.fieldset-head p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 12px;
}


.field-grid {
  display: grid;
  gap: 12px;
}

.field-grid.two {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.field-grid.three {
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
}

.form-actions {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
  flex-wrap: wrap;
  padding: 12px 0 4px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 70%);
  z-index: 2;
  border-top: 1px solid rgba(12, 20, 39, 0.06);
}

.btn,
.form-actions app-progress-button ::ng-deep button {
  border: none;
  border-radius: 12px;
  padding: 12px 18px;
  min-height: 44px;
  min-width: 132px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.btn.ghost,
.form-actions .ghost {
  background: #f1f5f9;
  color: #1f2937;
  border: 1px solid rgba(12, 20, 39, 0.08);
}

.btn.primary,
.form-actions app-progress-button ::ng-deep button.primary {
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
  color: #0b1021;
  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.24);
}

.btn:hover,
.form-actions app-progress-button ::ng-deep button.primary:hover {
  box-shadow: 0 14px 30px rgba(59, 130, 246, 0.28);
}

.form-actions button:active,
.form-actions app-progress-button ::ng-deep button:active {
  transform: translateY(1px);
}

.form-actions button[disabled],
.form-actions app-progress-button ::ng-deep button[disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}

::ng-deep .mat-dialog-container {
  padding: 12px;
}

@media (max-width: 720px) {
  .form-panel {
    padding: 14px;
    max-height: 68vh;
  }
  .fieldset {
    padding: 12px;
  }
  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/layouts/event-layout/event-form/event-form.component.css"],"names":[],"mappings":"AAAA;EACE,gFAAgF;EAChF,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wFAAwF;EACxF,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2EAA2E;EAC3E,UAAU;EACV,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yEAAyE;AAC3E;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,qDAAqD;EACrD,cAAc;EACd,gDAAgD;AAClD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".event-form-shell {\n  background: radial-gradient(120% 120% at 20% 20%, #f5f7fb, #e7ecf7 55%, #dfe6f5);\n  border-radius: 20px;\n  padding: 18px;\n  border: 1px solid rgba(12, 20, 39, 0.06);\n}\n\n.form-hero {\n  text-align: left;\n  margin-bottom: 18px;\n}\n\n.form-hero .badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.18);\n  color: #1d4ed8;\n  padding: 8px 14px;\n  border-radius: 999px;\n  font-size: 12px;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.form-hero h1 {\n  margin: 10px 0 6px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n  letter-spacing: -0.01em;\n}\n\n.form-hero p {\n  margin: 0;\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.form-panel {\n  background: #ffffff;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  border-radius: 18px;\n  box-shadow: 0 24px 70px rgba(45, 55, 72, 0.15);\n  padding: 18px;\n  max-height: 72vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.form-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  height: 100%;\n  min-height: 0;\n}\n\n.form-content {\n  display: grid;\n  gap: 14px;\n  overflow-y: auto;\n  padding-right: 4px;\n  min-height: 0;\n  flex: 1 1 auto;\n}\n\n.fieldset {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03), rgba(255, 255, 255, 0.96));\n  border: 1px solid rgba(12, 20, 39, 0.06);\n  border-radius: 14px;\n  padding: 14px;\n  display: grid;\n  gap: 12px;\n}\n\n.fieldset-head h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.fieldset-head p {\n  margin: 4px 0 0;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n\n.field-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.field-grid.two {\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n.field-grid.three {\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n}\n\n.form-actions {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n  padding: 12px 0 4px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 70%);\n  z-index: 2;\n  border-top: 1px solid rgba(12, 20, 39, 0.06);\n}\n\n.btn,\n.form-actions app-progress-button ::ng-deep button {\n  border: none;\n  border-radius: 12px;\n  padding: 12px 18px;\n  min-height: 44px;\n  min-width: 132px;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;\n}\n\n.btn.ghost,\n.form-actions .ghost {\n  background: #f1f5f9;\n  color: #1f2937;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n}\n\n.btn.primary,\n.form-actions app-progress-button ::ng-deep button.primary {\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n  color: #0b1021;\n  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.24);\n}\n\n.btn:hover,\n.form-actions app-progress-button ::ng-deep button.primary:hover {\n  box-shadow: 0 14px 30px rgba(59, 130, 246, 0.28);\n}\n\n.form-actions button:active,\n.form-actions app-progress-button ::ng-deep button:active {\n  transform: translateY(1px);\n}\n\n.form-actions button[disabled],\n.form-actions app-progress-button ::ng-deep button[disabled] {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n::ng-deep .mat-dialog-container {\n  padding: 12px;\n}\n\n@media (max-width: 720px) {\n  .form-panel {\n    padding: 14px;\n    max-height: 68vh;\n  }\n  .fieldset {\n    padding: 12px;\n  }\n  .form-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
